const context = require.context('.', true, /\.js$/)
const modules = []

context.keys().forEach((key) => {
  if (key.endsWith('/index.js')) return // Skip index files in any directory

  const fileExports = context(key)
  const defaultExport = fileExports.default

  // Only assign if a default export is found (as per requirement)
  if (defaultExport !== undefined) {
    modules.push(defaultExport)
  }
})

export default modules.flat()
